import React, { useEffect } from 'react';
import Home from "./pages/Home";

function App() {
  useEffect(() => {
    // Инициализация Telegram Web App
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      
      // Разворачиваем приложение на весь экран
      tg.expand();
      
      // Включаем полноэкранный режим
      tg.isVerticalSwipesEnabled = false;
      
      // Настраиваем внешний вид
      tg.headerColor = '#1e1e20';
      tg.backgroundColor = '#1e1e20';
      
      // Готово к использованию
      tg.ready();
      
      // Предотвращаем закрытие при свайпе вниз
      tg.onEvent('viewportChanged', () => {
        tg.expand();
      });
    }
    
    // Дополнительная защита от нежелательных свайпов
    const preventPullToRefresh = (e) => {
      if (e.touches.length === 1 && e.touches[0].clientY > 0) {
        const element = e.target;
        const scrollTop = element.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
        
        if (scrollTop === 0 && e.touches[0].clientY > e.touches[0].startY) {
          e.preventDefault();
        }
      }
    };
    
    document.addEventListener('touchstart', (e) => {
      e.touches[0].startY = e.touches[0].clientY;
    });
    
    document.addEventListener('touchmove', preventPullToRefresh, { passive: false });
    
    return () => {
      document.removeEventListener('touchmove', preventPullToRefresh);
    };
  }, []);

  return <Home/>;
}

export default App;
